import { useSelector } from 'react-redux';
import { MenuGroup } from './menu-group';
import { MenuItem } from './menu-item';
import './style.scss';
// import sidebarBg from '../../../assets/images/sidebar-bg.png';
import { useEffect, useState } from 'react';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import { ISystemMenuItem, SystemMenuType } from '../../../../model/system/menu';

import { IRootState } from '../../../../store/reducers';
import {
  getObject,
  setObject,
} from '../../../../lib/local-storage/interface-base';

interface IProps {
  // readonly onMouseEnter: () => void;
  // readonly onMouseLeave: () => void;
  readonly onCollapsedChange?: (Collapsed: boolean) => void;
  readonly collapsed?: boolean;
  readonly menus?: ISystemMenuItem[];
  readonly showHeader?: boolean;
  readonly showFooter?: boolean;
}
export const AdminLeftSide = (props: IProps) => {
  const selectMenuId = useSelector(
    (state: IRootState) => state.common.selectMenuId
  );
  const [menus, setMenus] = useState<ISystemMenuItem[]>([]);

  const [collapsed, setCollapsed] = useState<boolean>(
    getObject<boolean>('menuCollapsed') || false
  );

  const handleCollapsedChange = (newCollapsed: boolean) => {
    setCollapsed(newCollapsed);
    if (props.onCollapsedChange) {
      props.onCollapsedChange(newCollapsed);
    }
  };

  const toggleMenu = () => {
    const newCollapsed = !collapsed;
    setCollapsed(newCollapsed);
    setObject<boolean>('menuCollapsed', newCollapsed); // 保存展开/折叠状态
    handleCollapsedChange(newCollapsed); // 更新
  };

  useEffect(() => {
    if (props.menus && props.menus.length > 0) {
      setMenus(props.menus);
    }
  }, [props.menus]);

  const renderMenu = (menu: ISystemMenuItem) => {
    if (menu.hidden) {
      return null;
    }
    if (menu.type === SystemMenuType.Group) {
      return (
        <MenuGroup key={menu.id} menu={menu} selectedMenuId={selectMenuId} />
      );
    }
    if (menu.type === SystemMenuType.Menu) {
      return (
        <MenuItem key={menu.id} menu={menu} selectedMenuId={selectMenuId} />
      );
    }
  };

  return (
    <div
      className={`support-sidebar gc-console-sidebar ${
        collapsed ? 'collapsed' : ''
      }`}
      style={{ paddingTop: '48px' }}
    >
      <div className="gc-sidebar">
        <div className="sidebar-bg">{/* <img src={sidebarBg} /> */}</div>
        <div className="sidebar-body" style={{ paddingBottom: 20 }}>
          {menus.map((menu) => renderMenu(menu))}
        </div>

        <div className="sidebar-collapse-button" onClick={toggleMenu}>
          {collapsed ? <RightOutlined /> : <LeftOutlined />}
        </div>
      </div>
    </div>
  );
};
